/** Local allowlist parser: never fetch arbitrary URLs or follow redirects. */
export function providerUrl(raw: string): { url: string; embed?: string } | null {
  try {
    const u = new URL(raw);
    if (u.protocol !== 'https:' || u.username || u.password || u.port) return null;
    if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'].includes(u.hostname)) {
      const id =
        u.hostname === 'youtu.be'
          ? u.pathname.slice(1)
          : u.pathname.startsWith('/shorts/')
            ? u.pathname.split('/')[2]
            : u.pathname === '/watch'
              ? u.searchParams.get('v')
              : null;
      if (id && /^[A-Za-z0-9_-]{11}$/.test(id))
        return {
          url: `https://www.youtube.com/watch?v=${id}`,
          embed: `https://www.youtube-nocookie.com/embed/${id}`,
        };
      return null;
    }
    if (
      ['twitch.tv', 'www.twitch.tv'].includes(u.hostname) &&
      /^\/(?:videos\/\d+|[A-Za-z0-9_]{1,25})\/?$/.test(u.pathname)
    )
      return { url: `https://www.twitch.tv${u.pathname}` };
    return null;
  } catch {
    return null;
  }
}
